import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';

const ApprovalCampListing = ({
  getApprovalCampList,
  campApprove,
  match,
  campApproval,
  campReject,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    if (getApprovalCampList !== null) {
      (async () => {
        setIsLoading(true);
        await getApprovalCampList(1);
        setIsLoading(false);
      })();
    }
  }, [getApprovalCampList]);

  const Headers = [
    'Meeting Subject',
    'Site Number',
    'Scheduled Date',
    'Scheduled Time',
    'Meeting Status',
    'Approve/Reject',
    'Action',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'subject',
      'site_no',
      'scheduled_date',
      'scheduled_time',
      'statusName',
      'Approve/Reject',
    ];

    if (campApprove !== {} && campApprove) {
      const data = campApprove.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            'Approve/Reject': element.status === 0 ? '' : 'No',
            Actions: {
              name: 'View Details',
              link: `${baseUrl}/brand-activation/conduct-camp/details/${element.id}`,
            },
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(campApprove.total / campApprove.per_page));
    }
  }, [campApprove, baseUrl]);

  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      await campApproval(data.actionObj.id).then(async (response) => {
        if (response) {
          await getApprovalCampList(1);
          setIsModal(true);
        }
      });
    } else {
      setIsModal(true);
    }
  };

  const handleContinue = async () => {
    await campReject(actionData.actionObj.id).then(async (response) => {
      if (response) {
        await getApprovalCampList(1);
        setIsModal(false);
        setIsSuccessModel(true);
      }
    });
  };
  const handleModalHide = () => setIsModal(false);
  const handleRejectModalHide = () => setIsSuccessModel(false);

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to="#" onClick={func} className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getApprovalCampList(val.selected + 1, filter);
    setIsLoading(false);
  };

  // useEffect(() => {
  //   (async () => {
  //     await getListFilterData(3);
  //   })();
  // }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  // const getZones = (val) => {
  //   if (val) fetchZones(val);
  // };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData({ ...filterData });
    await getApprovalCampList(1, filterData);
    setIsLoading(false);
    filterToggle();
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.approvals}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        headers={Headers}
        isId={false}
        detailList={campApprove && campApprove.resultSets}
        onChange={(data) => updateApproval(data)}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={campApprove?.from}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        status={[
          { name: 'Under Approval', id: 0 },
          { name: 'Approved', id: 1 },
          { name: 'Rejected', id: 2 },
        ]}
        filterApprovalCampListing
      />

      <ModalPop
        title={localization.updatedSuccessfully}
        show={isStatusSuccess}
        handleModalHide={closeSuccess}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadStatusupdatedsuccessfully}</h5>
          <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
            {localization.continue}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>

      <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={handleModalHide}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <Fragment>
            <div className="modal-body">
              <div className="text-center">
                <h5>{localization.rejectCamp}</h5>
                <Button
                  className="btn btn-primary"
                  onClick={() => {
                    handleContinue();
                  }}
                >
                  {localization.continue}{' '}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            {successIconBox(localization.campApprovalSuccess, handleModalHide)}
          </Fragment>
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox(localization.campRejectSuccess, handleRejectModalHide)}
      </ModalPop>
    </Layout>
  );
};

ApprovalCampListing.propTypes = {};

export default ApprovalCampListing;
